import FormJaivana from 'dashboard_jaivana_v1';
/**
 *
 * @author Anderson Acevedo
 * 
 * @version jdesk_1.01.0003
 */
/**
 * CustomImprimirUbicaciones
 **/
class CustomImprimirUbicaciones extends FormJaivana.form {

    constructor(props) {

        super(props);
        this.initForm = this.initForm.bind(this);


        this.limpiarCampos = this.limpiarCampos.bind(this);
        this.gridOptionsComponentes = Object.assign({}, this.gridOptions);
        this.onSelectionChangedPrincipal                                  = this.onSelectionChangedPrincipal.bind(this);
        this.gridOptionsComponentes['onSelectionChanged']           = this.onSelectionChangedPrincipal;

        this.mostrarMensajeNoHayDatos = this.mostrarMensajeNoHayDatos.bind(this);
        this.mostrarMensajeAdicional = this.mostrarMensajeAdicional.bind(this);
        this.mostrarMensajeGenerando = this.mostrarMensajeGenerando.bind(this);
        this.traerPropiedades = this.traerPropiedades.bind(this);
        this.sucesstraerPropiedades = this.sucesstraerPropiedades.bind(this);

        this.generarArchivoTxt = this.generarArchivoTxt.bind(this);
        this.successManejarRespuesta = this.successManejarRespuesta.bind(this);
        this.consultarUbicaciones = this.consultarUbicaciones.bind(this);
        this.sucessconsultarUbicaciones = this.sucessconsultarUbicaciones.bind(this);
        this.isJson = this.isJson.bind(this);

        //imprimir

        this.mostrarMensajeEmailFallo                         =this.mostrarMensajeEmailFallo.bind(this);
        this.mostrarMensajeEmailEnviado                         =this.mostrarMensajeEmailEnviado.bind(this);


        this.currencyFormatterGeneral = this.currencyFormatterGeneral.bind(this);
        this.formatNumberSaldo = this.formatNumberSaldo.bind(this);
        this.sucursal_ingreso = '';
        this.numero_decimales = 2;
        this.fila_seleccionada=[];
        this.nombre_archivo='LPT1_';//impresora
    }

    initForm() {
        console.log('Formulario CustomImprimirUbicaciones,  @version: jdesk_1.01.0003, @author:Anderson Acevedo');
        this.sucursal_ingreso = JSON.parse(localStorage.getItem('sucursal_ingreso')).codigo_sucursal;
        this.traerPropiedades();

        this.getField('nombre_bodega').setOnChange((props) => {
            this.getField('nombre_bodega').setError(false,'');
            this.limpiarCampos();
            if(this.getField('nombre_bodega').getValue()!=='' && this.getField('nombre_bodega').getValue()!==' ')
                this.consultarUbicaciones();
        });

 
        this.getField('bt_imprimir').setClick(()=>{
            if(this.fila_seleccionada.length>0)
                this.getField('modal_stickers').handleClickOpen();
            else
                this.alertGeneral.toggle(true, 'Es necesario seleccionar un registro', 'error');

        });

        this.getField('bt_cancelar').setClick(()=>{
            this.getField('modal_stickers').handleClose();
        });

        this.getField('bt_aceptar').setClick(()=>{
            if(this.getField('cantidad_imprimir').valid())
                this.generarArchivoTxt();
        });



    }

    onSelectionChangedPrincipal(){
        this.fila_seleccionada = this.gridOptionsComponentes.api.getSelectedRows();
    }


    traerPropiedades() {
        let datos = { datos: {
            sucursal_ingreso:this.sucursal_ingreso
        } };
        this.generalFormatPmv = { tipo_servicio: 'inve-imprimirubicaciones', operacion: 'traerpropiedades', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.sucesstraerPropiedades,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });

    }

    sucesstraerPropiedades(data) {
        this.getField('confirmModalCustom').toggle(false);
        
        if (data.estado_p === 200) {
            this.numero_decimales = data.data.numero_decimales;
            this.wms_nuevo = data.data.wms_nuevo;

            if(this.wms_nuevo!=='N'){
                this.getField('bodega').setVisible(false);
                this.getField('nombre_bodega').setVisible(false);

                this.mostrarMensajeAdicional('OPCIÓN NO AUTORIZADA! (I0083)');
            }
        } else if (data.estado_p === 404) {
            //this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }

    consultarUbicaciones() {
        if(this.getField('bodega').valid() && this.getField('nombre_bodega').valid()){
            this.mostrarMensajeGenerando();
            let datos = { datos: {
                sucursal_ingreso:this.sucursal_ingreso,
                bodega:this.getField('bodega').getValue(),
            } };
            this.generalFormatPmv = { tipo_servicio: 'inve-imprimirubicaciones', operacion: '1_ubicaciones', operacion_tipo: 'consulta' };
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: datos,
                    success: this.sucessconsultarUbicaciones,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
                });
        }
    }

    sucessconsultarUbicaciones(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            //dibujar tabla
            this.getField("rejilla").toggle(true);
            this.gridOptionsComponentes["rowData"] = data.data;
            let configCell = new Map();

            this.getField('rejilla').initData(this.gridOptionsComponentes,configCell);
            this.getField('bt_imprimir').setVisible(true);
        } else if (data.estado_p === 404) {
            this.mostrarMensajeNoHayDatos();
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }



    limpiarCampos() {
        this.getField('rejilla').toggle(false);
        this.getField('bt_imprimir').setVisible(false);
        this.fila_seleccionada=[];

    }


    currencyFormatterGeneral(number) {
        let decimal = (number + "").split(".")[1];//para manejar los decimales
        if ((decimal !== 0) && (decimal !== undefined)) {
            if (decimal.length > this.numero_decimales) {
                number = number.toFixed(this.numero_decimales); //para que redondea a dos decimales
                decimal = (number + "").split(".")[1];
            }
            return (this.formatNumberSaldo(number) + "," + decimal);
        } else {
            return this.formatNumberSaldo(number);
        }
    }

    formatNumberSaldo(number) {
        return Number(number).toFixed(this.numero_decimales).toString().split('.')[0]
            .toString()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    }


    mostrarMensajeGuardando(){
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está guardando la información... `);
        this.getField('confirmModalCustom').setClickDialog(()=>{});  
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setClickCancelDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeAdicional(mensaje) {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', mensaje);
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setClickCancelDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog â€“ popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeGenerando() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está generando la información... `);
        this.getField('confirmModalCustom').setClickDialog(() => { });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);

    }

    mostrarMensajeNoHayDatos() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'La consulta no arrojo datos.');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    //mensajes correo

    mostrarMensajeEmailEnviado() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'Email enviado exitosamente...');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeEmailFallo() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', 'Error al enviar el email...');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }


    generarArchivoTxt() {
        this.mostrarMensajeGenerando();
        let url = this.constant.formConfiguration();
        let datos2 = {
            sucursal_ingreso: this.sucursal_ingreso,
            bodega: this.getField('bodega').getValue(),
            ubicacion: this.fila_seleccionada[0].ubicacion,
            cantidad_imprimir:this.getField('cantidad_imprimir').getValue(),
            
        }

        this.getField('modal_stickers').handleClose();


        const myJSON = JSON.stringify(datos2);
        let datos = '?body={"datos":' + myJSON + ',"generales":{"tipo_servicio":"inve-imprimirubicaciones","operacion":"imprimir","operacion_tipo":"consulta"}}';
        fetch(url + datos, {
            method: 'GET',
            headers: new Headers({
                "Authorization": 'Bearer ' + localStorage.getItem('token'),
                "Content-Type": 'application/json'
            })
        })
            .then(response => {
                this.getField('confirmModalCustom').toggle(false);
                if (response.status !== 200) {
                    return '';
                }
                const reader = response.body.getReader();
                return new ReadableStream({
                    start(controller) {
                        return pump();
                        function pump() {
                            return reader.read().then(({ done, value }) => {
                                if (done) {
                                    controller.close();
                                    return;
                                }
                                controller.enqueue(value);
                                return pump();
                            });
                        }
                    }
                })
            })
            .then(stream => new Response(stream))
            .then(response => response.blob())
            .then(blob => {
                if (blob.size > 0) {
                    blob.text().then(res => {
                        if (this.isJson(res)) {
                            this.successManejarRespuesta(JSON.parse(res));
                        } else {
                            const url = window.URL.createObjectURL(blob);
                            const a = document.createElement('a');
                            a.style.display = 'none';
                            a.href = url;
                            // the filename you want
                            this.nombre_archivo=this.nombre_archivo+this.fila_seleccionada[0].ubicacion;
                            a.download = this.nombre_archivo + '.txt';
                            document.body.appendChild(a);
                            a.click();
                            window.URL.revokeObjectURL(url);
                            alert('Se descargo el archivo!');
                        }
                    });
                } else {
                    this.mostrarMensajeNoHayDatos();
                }
            }).catch(err => {
                this.alertGeneral.toggle(true, err, 'error');
            });
    }

 

    successManejarRespuesta(data){
        this.getField('confirmModalCustom').toggle(false);
        if(data.estado_p === 200){
            //nada
        }else{
            //this.mostrarMensajeEmailFallo();
            let respuesta=Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }

    isJson(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }


}
FormJaivana.addController("inve-imprimirubicaciones", CustomImprimirUbicaciones);
export default CustomImprimirUbicaciones